// Observability bridge — replaces Sentry with our structured logger
// All existing captureException/setUser calls continue to work seamlessly
// Errors are captured locally and sent to CW Browser Admin via the insight pipeline

let currentUser = null;

export const initSentry = () => {
  // No-op: Sentry is replaced by CW Browser's observability system
  // Errors are captured via the structured logger → anomaly detector → Admin relay
};

export const captureException = (error, context) => {
  // Forward to our structured logger via IPC
  if (window.electronAPI?.observability?.log) {
    const errorData = {
      name: error?.name || "Error",
      message: error?.message || String(error),
      stack: error?.stack || "",
      ...(context || {}),
      user: currentUser,
    };
    window.electronAPI.observability.log("error", "render", errorData.message, errorData);
  } else {
    // Fallback for non-Electron environment (shouldn't happen, but safe)
    console.error("[Observability] captureException:", error, context);
  }
};

export const setUser = (user) => {
  currentUser = user;
};

// Compat export — code that imports { Sentry } can still reference it
export const Sentry = {
  captureException,
  setUser,
  init: initSentry,
};
